export function calculateShiftSelection<T>(
  rowData: T,
  rows: T[],
  selectedByKey: Map<string, T>,
  lastClickedRowKey: string,
  extractRowKey: (rowData: T) => string
): Map<string, T> {
  const selectedRowKey = extractRowKey(rowData)
  if (selectedByKey.size === 0) {
    return new Map([[selectedRowKey, rowData]])
  }
  const isTargetRowSelected = selectedByKey.has(selectedRowKey)

  const lastSelectedRowIndex = rows.findIndex(
    (row) => extractRowKey(row) === lastClickedRowKey
  )
  const selectedRowIndex = rows.findIndex(
    (row) => extractRowKey(row) === selectedRowKey
  )

  if (lastSelectedRowIndex === -1 || selectedRowIndex === -1) {
    const newSelection = new Map(selectedByKey) // deep copy of current state for mutation
    // either the last selected row or the selected row is not in view, toggle the target row
    if (isTargetRowSelected) {
      newSelection.delete(selectedRowKey)
    } else {
      newSelection.set(selectedRowKey, rowData)
    }
    return newSelection
  }

  const rowsBetweenArray = rows.slice(
    Math.min(lastSelectedRowIndex, selectedRowIndex),
    Math.max(lastSelectedRowIndex, selectedRowIndex) + 1
  )

  const newSelection = new Map(selectedByKey) // deep copy of current state for mutation
  if (isTargetRowSelected) {
    // unselect all rows in between the last selected row and the selected row
    for (const row of rowsBetweenArray) {
      if (newSelection.has(extractRowKey(row))) {
        newSelection.delete(extractRowKey(row))
      }
    }
    return newSelection
  }

  for (const row of rowsBetweenArray) {
    // select all rows in between the last selected row and the selected row
    newSelection.set(extractRowKey(row), row)
  }
  return newSelection
}
